module.exports = __webpack_public_path__ + "img/EDQ16_L.3698b69d.png";